import React, { FC } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import { I18nText } from 'src/components/i18n';
import { getDDMMYYYY } from 'src/utils/helpers';

export const ShipownerOfferListMobileItem: FC<any> = ({ offer }) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { orderId } = useParams<any>();

  return (
    <Paper className={classes.paper}>
      <Grid
        container
        className={classes.gridContainer}
        alignContent="center"
        justifyContent="center"
      >
        <Grid item className={classes.gridItem} xs={12}>
          <div className={classes.label}>
            <I18nText path="menuLabel.id" />:
          </div>
          <div className={classes.id}>{offer.indexNumber}</div>
        </Grid>
        <Grid item className={classes.gridItem} xs={12}>
          <div className={classes.label}>
            <I18nText path="menuLabel.carrier" />:
          </div>
          <div>{offer.carrier}</div>
        </Grid>
        <Grid item className={classes.gridItem} xs={12}>
          <div className={classes.label}>
            <I18nText path="menuLabel.proposal" />:
          </div>
          <div>{offer.proposal}</div>
        </Grid>
        <Grid item className={classes.gridItem} xs={12}>
          <div className={classes.label}>
            <I18nText path="menuLabel.freightRate" />:
          </div>
          <div>{offer.freightRate}</div>
        </Grid>
        <Grid item className={classes.gridItem} xs={12}>
          <div className={classes.label}>
            <I18nText path="menuLabel.eta" />:
          </div>
          <div>{getDDMMYYYY(offer.eta)}</div>
        </Grid>
        <Grid item className={classes.gridItem} xs={12}>
          <div className={classes.label}>
            <I18nText path="menuLabel.draft" />:
          </div>
          <div>{offer.draft}</div>
        </Grid>
        <Grid item className={classes.gridItem} xs={12}>
          <div className={classes.label}>
            <I18nText path="menuLabel.deadWeight" />:
          </div>
          <div>{offer.deadweight}</div>
        </Grid>
        <Grid item className={classes.gridItem} xs={12}>
          <div className={classes.label}>
            <I18nText path="menuLabel.demRate" />:
          </div>
          <div>{offer.demRate}</div>
        </Grid>
        <Grid item className={classes.gridItem} xs={12}>
          <Button
            className={classes.openButton}
            variant="contained"
            onClick={() => navigate(`/shipowner/offer/edit/${orderId}/${offer.id}`)}
          >
            <I18nText path="button.edit" />
          </Button>
        </Grid>
      </Grid>
    </Paper>
  );
};

const useStyles = makeStyles(theme => ({
  paper: {
    borderRadius: '16px',
    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.06)',
    padding: '20px 15px',
    marginBottom: '20px',
  },
  gridContainer: {
    height: '100%',
  },
  gridItem: {
    fontSize: '16px',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'fles-start',
    marginBottom: '15px',
    flexDirection: 'column',
  },

  openButton: {
    color: '#2A39BE',
    backgroundColor: 'rgba(42, 57, 190, 0.1)',
    borderRadius: '8px',
    boxShadow: 'none',
    height: '55px',
    fontSize: '16px',
    textTransform: 'none',
    padding: '0 33px',
  },
  id: {
    fontWeight: 'bold',
    fontSize: '16px',
  },
  layCanWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'start',
    flexDirection: 'column',
  },
  buttonsWrapper: {
    fontSize: '16px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  label: {
    marginBottom: '5px',
    fontSize: '13px',
  },
}));
